import React, { Fragment } from 'react';

const ShouldRender = ({condition, children})=>
<Fragment>
  {condition && children}
</Fragment>

export default ShouldRender;